import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "../components/Navbar";
import YachtCard from "../components/YachtCard";
import YachtModal from "../components/YachtModal";
import { testimonialsData, yachtsData } from "../data";
import { CiMenuBurger } from "react-icons/ci";
import { IoMdClose, IoMdMenu } from "react-icons/io";
import { YachtContext } from "../context/YachtContext";
import Faq from "../components/Faq";
import { Link } from "react-router-dom";
import SkeletonCard from "../components/SkeletonCard";
import { Helmet } from "react-helmet-async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";

const Home = () => {
  const {
    fetchAllYachts,
    allYachts,
    loading,
    categories,
    fetchCategoriesAndYachts,
  } = useContext(YachtContext);
  const [selectedYacht, setSelectedYacht] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [filterSelect, setFilterSelect] = useState(false);
  const [filteredYachts, setFilteredYachts] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const yachtsPerPage = 6;

  const indexOfLastYacht = currentPage * yachtsPerPage;
  const indexOfFirstYacht = indexOfLastYacht - yachtsPerPage;
  const currentYachts = filteredYachts.slice(
    indexOfFirstYacht,
    indexOfLastYacht
  );
  const totalPages = Math.ceil(filteredYachts.length / yachtsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    fetchAllYachts();
    fetchCategoriesAndYachts();

    AOS.init({
      duration: 600,
      easing: "ease-in-sine",
    });
  }, [fetchAllYachts, fetchCategoriesAndYachts]);

  useEffect(() => {
    applyFilters();
  }, [allYachts, selectedFilter]);

  const applyFilters = () => {
    let yachts = [...allYachts];

    if (selectedFilter === "All") {
      setFilteredYachts(yachts);
    } else if (selectedFilter === "Price: High to Low") {
      yachts.sort(
        (a, b) => b.price_details[0].price - a.price_details[0].price
      );
      setFilteredYachts(yachts);
    } else if (selectedFilter === "Price: Low to High") {
      yachts.sort(
        (a, b) => a.price_details[0].price - b.price_details[0].price
      );
      setFilteredYachts(yachts);
    } else {
      // Filter by category
      yachts = yachts.filter(
        (yacht) => yacht.category[0].category_url === selectedFilter
      );
      setFilteredYachts(yachts);
    }
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    // setIsFilterOpen(false);
  };

  const navbarRef = useRef(null);
  // const swiperRef = useRef(null);
  const scrollToNavbar = () => {
    if (navbarRef.current) {
      navbarRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleOpenModal = (yacht) => {
    setSelectedYacht(yacht);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Helmet>
        <title>Yacht Rental Dubai | Luxury Charters & Boat Rentals - BlueHarbour</title>
        <meta
          name="keywords"
          content="Yacht rental dubai, Dubai yacht rental, Yacht rental dubai marina, Yachts rental dubai, Luxury yacht rental dubai, Yachts rental dubai price, Yacht rentals in dubai, Dubai yacht rentals, Party yacht rental dubai, Small yacht rental dubai, Private yacht rental dubai, Dubai yacht rental prices, Luxury yacht rental in dubai, Birthday yacht rental dubai, Yacht rental dubai for birthday, Yacht rental dubai new year’s eve, Yacht rental dubai party, Yacht rental in dubai prices, Best yacht rental dubai, Dubai marina yacht rental, Yacht rental marina dubai price, Dubai luxury yacht rental, Yacht rental dubai for couples, Luxury yacht rental dubai marina"
        />
        <meta name="description" content=" Experience top-rated yacht rental Dubai Marina with BlueHarbour. Luxury charters, private boat rentals, party cruises & sunset tours available daily." />
      </Helmet>
      <main id="home">
        <Navbar navbarRef={navbarRef} />

        <section className="section-2 pc-section d-md-block d-none">
          <div className="">
            <Swiper
              className="mainswiper"
              loop={true}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              speed={500}
              effect="fade"
              modules={[Pagination, Autoplay, EffectFade]}
              pagination={{ clickable: true }}
            >
              {[
                {
                  img: "assets/yachtimages/luxe.webp",
                  title: "LUXURY YACHTS",
                  text: "Indulge in elite comfort with our LUXE private yacht rental in Dubai.",
                },
                {
                  img: "assets/yachtimages/prime.webp",
                  title: "PRIME YACHTS",
                  text: "Celebrate in style with our PRIME yachts — your perfect choice for party yacht rental in Dubai.",
                },
                {
                  img: "assets/yachtimages/eco.webp",
                  title: "ECONOMY YACHTS",
                  text: "Smart, stylish, and affordable — our ECONOMY range is ideal for small yacht rental in Dubai.",
                },
              ].map((yacht, index) => (
                <SwiperSlide key={index}>
                  <img src={yacht.img} alt={yacht.title} />
                  <div className="overlay"></div>
                  <div className="info-box">
                    <h2>{yacht.title}</h2>
                    <p>{yacht.text}</p>
                    {/* <p>Capacity: 30 Person</p>
                                    <p>Crew 3 Member</p> */}
                    <Link to="/yacht-rental-dubai">
                      <button className="book-btn">View More</button>
                    </Link>
                  </div>
                </SwiperSlide>
              ))}
              <div className="swiper-pagination"></div>
            </Swiper>
          </div>
        </section>

        <section className="section2mobile d-md-none d-block">
          <div className="section2_bg_image d-flex align-items-center">
            <div className="px-3">
              <h1 className="text-white">
                Blue Harbour Yacht Rentals in Dubai
              </h1>
              <p className="text-white">
                Elevate your Dubai experience with Blue Harbour — a premier
                yacht rental company offering exclusive service, a dedicated
                crew, and complimentary onboard drinks.
              </p>

              <Link to="/yacht-rental-dubai">
                <button className="book-btn">See Our Yachts</button>
              </Link>

              <Link to="https://api.whatsapp.com/send?phone=971566265785">
                <button className="book-btn2">
                  <FontAwesomeIcon icon={faWhatsapp} /> Book Now
                </button>
              </Link>

              <div className="social_icon">
                <a href="">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.instagram.com/blueharbouryachts/">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a href="">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
                <a href="">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
              </div>
              <p>
                <b>
                  <i>Top-Rated Exclusive Yacht Rental in Dubai</i>
                </b>
              </p>
            </div>
          </div>
        </section>
        <section className="section-3">
          <div className="bg-color">
            <div className="container">
              <div className="d-md-flex justify-content-between">
                <h2>
                  Reserve <br className="d-md-block d-none" />
                  the Luxury
                </h2>
                <div>
                  <h3 className="text-md-end mb-3">Find The Right Yacht</h3>

                  <div
                    id="filter-sidebar"
                    className={`${isFilterOpen ? "active" : ""}`}
                  >
                    <div className="filter-header d-flex justify-content-end align-items-center">
                      <div className="filter-options me-3">
                        <span
                          className={`filter-badge ${
                            selectedFilter === "All" ? "active" : ""
                          }`}
                          onClick={() => handleFilterChange("All")}
                        >
                          All
                        </span>

                        {categories.map((category) => (
                          <span
                            key={category.category_url}
                            className={`filter-badge ${
                              selectedFilter === category.category_url
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(category.category_url)
                            }
                          >
                            {category.category_url}
                          </span>
                        ))}

                        <span
                          className={`filter-badge ${
                            selectedFilter === "Price: High to Low"
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            handleFilterChange("Price: High to Low")
                          }
                        >
                          Price: High to Low
                        </span>

                        <span
                          className={`filter-badge ${
                            selectedFilter === "Price: Low to High"
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            handleFilterChange("Price: Low to High")
                          }
                        >
                          Price: Low to High
                        </span>
                      </div>
                      <IoMdClose
                        id="close-filter"
                        onClick={() => setIsFilterOpen(false)}
                      />
                    </div>
                  </div>

                  <div
                    className={`filters d-flex justify-content-end align-items-center ${
                      isFilterOpen ? "hidden" : ""
                    }`}
                  >
                    <span id="filter-text">Filters</span>
                    <IoMdMenu
                      id="filter-icon"
                      fontSize={22}
                      className={`${
                        isFilterOpen ? "close" : ""
                      } ms-3 cursor-pointer`}
                      onClick={() => setIsFilterOpen(true)}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-lg-5 mt-3">
                {loading
                  ? Array.from({ length: 3 }).map((_, index) => (
                      <div key={index} className="col-lg-4 mb-4">
                        <SkeletonCard />
                      </div>
                    ))
                  : currentYachts.length > 0
                  ? currentYachts.map((yacht) => (
                      <div
                        key={yacht.id}
                        className="col-lg-4 mt-3 h-auto"
                        data-aos="fade"
                      >
                        <YachtCard
                          yacht={yacht}
                          onOpenModal={handleOpenModal}
                        />
                      </div>
                    ))
                  : null}
              </div>
            </div>
            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-3 pt-4">
                <button
                  className="btn btn-outline-light"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="text-white">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-outline-light"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            )}
          </div>
          <YachtModal
            yacht={selectedYacht}
            show={showModal}
            handleClose={handleCloseModal}
          />
        </section>

        <section className="section-4">
          <div className="row gx-0">
            <div className="col-lg-8">
              <div className="wrapper">
                <h2>
                  KEY CONSIDERATIONS WHEN <br /> RENTING A LUXURY YACHT IN DUBAI
                </h2>
                <p className="">
                  Looking for a yacht rental in Dubai for a birthday, or want a
                  yacht rental for couples? Blue Harbour offers a hassle-free
                  luxury yacht rental process. Rent a yacht in Dubai Marina for
                  a corporate event or a party in easy steps:
                </p>
                <div className="row gx-0 my-4">
                  <div className="col-md-4 mb-2">
                    <div className="bg-gradient" data-aos="fade-left">
                      <img
                        src="assets/yachtimages/number-1.png"
                        alt=""
                        className="icon"
                      />

                      <p>
                        Browse our luxury yachts in Dubai and choose the one
                        that suits your event and guest count best.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div className="bg-gradient" data-aos="fade-left">
                      <img
                        src="assets/yachtimages/number-2.png"
                        alt=""
                        className="icon"
                      />

                      <p>
                        Pick your time and date, and send us your booking
                        request. You will receive the confirmation via email.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div className="bg-gradient" data-aos="fade-left">
                      <img
                        src="assets/yachtimages/number-3.png"
                        alt=""
                        className="icon"
                      />
                      {/* <h4>CHARTERS</h4> */}
                      <p>
                        Secure your booking with payment, and get ready for a
                        fun-filled day!
                      </p>
                    </div>
                  </div>
                </div>
                <h3>Nedd Help?</h3>
                <div className="mt-md-3 mt-2">
                  <Link to="/contact-us">
                    <button>Contact Us</button>
                  </Link>
                  <button
                    style={{ backgroundColor: "#25d366", marginLeft: "10px" }}
                  >
                    Whatsapp
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-4" data-aos="fade">
              <img src="assets/yachtimages/key.webp" alt="" />
            </div>
          </div>
        </section>

        <section className="section-5" data-aos="fade">
          <div className="container">
            <h2>
              Luxury Yacht Rental Services in Dubai – Come Sail Dubai, Habibi!
            </h2>
            <p className="my-md-4">
              Blue Harbour sets the standard for Dubai luxury yacht rental with
              curated catering, elegant decor, water activities- jet skiing,
              paddleboarding, and more, upon request.
            </p>
            <div className="row gx-0 mt-3">
              <div className="col-lg-4 col-md-6" data-aos="fade-right">
                <div className="image-wrapper">
                  <img src="assets/images/bhy-yacht-catering.webp" alt="" />
                </div>
                <div className="content">
                  <h6>Catering </h6>
                  <Link to="/yacht-rental-services-dubai">
                    <span>
                      Know More <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-4 col-md-6" data-aos="fade-up">
                <div className="image-wrapper">
                  <img src="assets/images/bhy-yacht-decor.webp" alt="" />
                </div>
                <div className="content">
                  <h6>Decor </h6>
                  <Link to="/yacht-rental-services-dubai">
                    <span>
                      Know More <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-4 col-md-6" data-aos="fade-left">
                <div className="image-wrapper">
                  <img src="assets/images/bhy-water-sports.webp" alt="" />
                </div>
                <div className="content">
                  <h6>Watersports </h6>
                  <Link to="/yacht-rental-services-dubai">
                    <span>
                      Know More <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-4 col-md-6" data-aos="fade-up">
                <div className="image-wrapper">
                  <img src="assets/images/bhy-jet-ski-rental.webp" alt="" />
                </div>
                <div className="content">
                  <h6>Jet Ski Rentals</h6>
                  <Link to="/yacht-rental-services-dubai">
                    <span>
                      Know More <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-4 col-md-6" data-aos="fade-up">
                <div className="image-wrapper">
                  <img src="assets/images/bhy-luxury-transport.webp" alt="" />
                </div>
                <div className="content">
                  <h6>Luxury Car Transport </h6>
                  <Link to="/yacht-rental-services-dubai">
                    <span>
                      Know More <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-6 gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="gallery-container">
                  <div className="row gx-3 gy-md-3 gy-2">
                    <div className="col-md-4" data-aos="fade-right">
                      <div className="row gy-3 gx-2">
                        <div className="col-md-12 col-6">
                          <img
                            src="assets/yachtimages/01.webp"
                            alt="Gallery Image"
                            className="image-1"
                          />
                        </div>
                        <div className="col-md-12 col-6">
                          <img
                            src="assets/yachtimages/02.webp"
                            alt="Gallery Image"
                            className="image-4"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8" data-aos="fade-left">
                      <div className="row gy-md-3 gy-2 gx-2">
                        <div className="col-6">
                          <img
                            src="assets/yachtimages/03.webp"
                            alt="Gallery Image"
                            className="image-2"
                          />
                        </div>
                        <div className="col-6">
                          <img
                            src="assets/yachtimages/04.webp"
                            alt="Gallery Image"
                            className="image-3"
                          />
                        </div>
                        <div className="col-md-12 col-6">
                          <img
                            src="assets/yachtimages/05.webp"
                            alt="Gallery Image"
                            className="image-5"
                          />
                        </div>
                        <div className="col-md-12 col-6">
                          <img
                            src="assets/yachtimages/06.webp"
                            alt="Gallery Image"
                            className="image-6"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12" data-aos="fade-up">
                      <img
                        src="assets/yachtimages/07.webp"
                        alt="Gallery Image"
                        className="image-7"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mt-lg-0 mt-3" data-aos="fade">
                <div className="wrapper">
                  <h3>
                    The ones who's <br /> <b>Experienced Luxury</b>
                  </h3>
                  <Swiper
                    className="mySwiper2 mt-lg-5"
                    pagination={{ clickable: true }}
                    modules={[Pagination]}
                  >
                    {testimonialsData.map((testimonial) => (
                      <SwiperSlide key={testimonial.id}>
                        <div className="testimonial">
                          <p>{testimonial.data}</p>
                          <div className="testimonial-profile d-flex">
                            <img
                              src="user.png"
                              className="profile-image"
                              alt=""
                            />
                            <div className="text-content ms-3">
                              <h6>{testimonial.name}</h6>
                              <p>{testimonial.location}</p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                    <div className="swiper-pagination"></div>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-7">
          <div className="container">
            <h2>Got any Questions?</h2>
            <p className="my-3" style={{ color: "#fff" }}>
              Have queries? We’re here to help! Looking for yacht rentals in
              Dubai? Whether it's about pricing, additional services or special
              requests, Blue Harbour is happy to assist. Contact us today and
              let’s plan your luxury yacht experience!
            </p>

            <Faq />
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;
